
export default {
  data() {
    return {
      bizParam1: {
        "isOnlyCamera": null,
        "isAddWaterMark": null,
        "signLocation": {
          // 签到位置
          "maxRadius": 2000,
          "allowOutside": 'Y'
        },
        "isFastAdd": 'Y', //快速建档
        // 规则（专病、拜访）
        "selectItemNum": {
          "enabled": false,
          "limitMax": null,
          "ruleItemList": []
        },
        // 规则13
        checkIntervalTime: {
          enabled: false,
          intervalTime: null,
        },
        //规则2（专病、拜访）
        "dayItemBelongSameCustomer": {
          "enabled": false,
          "isSamePerson": null,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "3",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "10",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "15",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
          ]
        },
        //规则9（专病、拜访）
        "diyDayItemBelongSameCustomer": {
          "enabled": false,
          "dayLimitMax": null,
           "isSamePerson": null,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "3",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "10",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "15",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
          ]
        },
        //规则3（专病、拜访）
        "dayItemSum": {
          "enabled": false,
          "isSamePerson": null,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "3",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "10",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "11",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "15",
              "sumLimitMax": null
            },
          ]
        },
        //规则10（专病、拜访）
        "diyDayItemSum": {
          "enabled": false,
          "dayLimitMax": null,
          "isSamePerson": null,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "3",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "10",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "11",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "15",
              "sumLimitMax": null
            },
          ]
        },
        //规则4（专病、拜访）
        "dayCustomerSumAndSame": {
          "enabled": false,
          "isSamePerson": null,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "1",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "2",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "4",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "14",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
          ]
        },
        //规则11
        "diyDayCustomerSumAndSame": {
          "enabled": false,
          "isSamePerson": null,
           "dayLimitMax": null,

          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "1",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "2",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "4",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "14",
              "sameLimitMax": null,
              "sumLimitMax": null
            },
          ]
        },
        //规则5（专病、拜访）
        "monthItemSameSum": {
          "enabled": false,
          "isSamePerson": null,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "3",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "10",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "11",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "15",
              "sumLimitMax": null
            },
          ]
        },
        //规则6（专病、拜访）
        "monthCustomerSameSum": {
          "enabled": false,
          "isSamePerson": null,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "1",
              "sumLimitMax": null,
              "isSamePersonExecute":null
            },
            {
              "enabled": false,
              "customerType": "2",
              "sumLimitMax": null,
              "isSamePersonExecute":null
            },
            {
              "enabled": false,
              "customerType": "4",
              "sumLimitMax": null,
              "isSamePersonExecute":null
            },
            {
              "enabled": false,
              "customerType": "14",
              "sumLimitMax": null,
              "isSamePersonExecute":null
            }
          ]
        },
        //规则6-1（专病、拜访）
        "dayCustomerSameSum": {
          "enabled": false,
          "isSamePerson": null,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "1",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "2",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "4",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "14",
              "sumLimitMax": null
            }
          ]
        },
        //规则12
        "diyDayCustomerSameSum": {
          "enabled": false,
          "isSamePerson": null,
          "dayLimitMax": null,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "1",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "2",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "4",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "14",
              "sumLimitMax": null
            }
          ]
        },
        //规则6-1（订单）
        "orderDayCustomerSameSum": {
          "enabled": false,
          "isSamePerson": null,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "药店",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "商业公司",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "医院",
              "sumLimitMax": null
            },
          ]
        },
        //规则7（专病）
        "dayCustomerSumNotSame": {
          "enabled": false,
          "isSamePerson": null,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "4",
              "sumLimitMax": null
            }
          ]
        },
        //规则8（三大报货、库存信息采集）
        "dayBizDataSum": {
          "enabled": false,
          "limitMax": null
        },
        "monthOrderSumProduct": {
          "enabled": false,
          "limitMax": null
        },
        "monthOrderSumCompetitor": {
          "enabled": false,
          "limitMax": null
        },
        //规则9（三大报货）
        "selectProductQtySum": {
          "enabled": false,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "单体药店",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "未定义类型的药店",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "连锁总部",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "连锁门店",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "医院",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "商业公司",
              "sumLimitMax": null
            }
          ]
        },
        //规则10（库存信息采集）
        "selectProductStockQty": {
          "enabled": false,
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "单体药店",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "未定义类型的药店",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "连锁总部",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "医院",
              "sumLimitMax": null
            },
            {
              "enabled": false,
              "customerType": "商业公司",
              "sumLimitMax": null
            }
          ]
        },
        //优位陈列规则1
        monthCustomerSameStaff : {
          "enabled": false,
          "isSamePerson": 'Y',
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "1",
              "sumLimitMax": null,
              "isSamePersonExecute":null
            }
          ]
        },
        //优位陈列规则1
        monthCustomerDifferentStaff : {
          "enabled": false,
          "isSamePerson": 'N',
          "ruleItemList": [
            {
              "enabled": false,
              "customerType": "1",
              "sumLimitMax": null,
              "isSamePersonExecute":null
            }
          ]
        },

        // 私域管理规则
        inputLimitPerDay: {
          max: 10,
          enabled: true
        },
        isVisitVisibleList: [],
        isChangePrice: '0', //报货
        orderState: '50', //报货
        isKcShow: 'N', //库存
        expiryDate: [], //库存有效期
        stockNum: [], //数量
        // 采集日期规则
        accountMonthCheckRule: {
          enabled: false,
          includeCurrentMonth: false,
          amount: 3
        },
      },
    };
  },
  methods: {
    changeData(val){
        this.bizParam1 = val;
    },
    checkProLot(){
      let functionCode = this.queryCode;
      let arr=[]
      arr=this.fieldList.filter(item=>
        item.fieldName == 'lotNo')
        let flg1=false
        let flg2=false
        flg1=functionCode == 'BHOTC' || functionCode == 'BHRX' || functionCode == 'BHSY' || functionCode == 'FKSXSDD' ||functionCode == 'FKSXSDD'
        flg2=this.bizParam1.declareGoodsType&&this.bizParam1.declareGoodsType=='2'&&((arr&&arr.length>0&&arr[0].formVisible!='Y')||!arr||arr.length==0)
      return flg1&&flg2
    },
    //提交
    saveReq(type) {
      let functionCode = this.queryCode;
      if (this.tenantName == '') {
        this.$message.error('请选择应用公司');
        return;
      }
      if (this.fieldList.length == 0) {
        this.$message.error('请添加字段');
        return;
      }
      
      if(this.checkProLot()){
        this.$message.error('按产品批号采集需展示产品批号');
        return
        
      }
      let tenantGuid = this.tenantGuid;
      this.sendTenantList.forEach((item) => {
        if (item.tenantName == this.tenantName) {
          tenantGuid = item.guid;
        }
      });

      let organisationGuid = this.organisationGuid;
      let organisationName;
      this.organisationList.forEach((item) => {
        if (item.guid == organisationGuid) {
          organisationName = item.organisationName;
        }
      });
      if (functionCode == 'YWCL' && !this.$refs.goodsShowRuleConfig.checkResult()) return;
      if (functionCode == 'SCDY' && !this.$refs.markingRuleConfig.checkResult()) return;
      if (functionCode == 'JPXXSJ' && !this.$refs.competitionRuleConfig.checkResult()) return;
      if (functionCode == 'ZBHZTJ' && !this.$refs.zbRuleConfig.checkResult()) return;
      if (functionCode == 'KCXXCJ' && !this.$refs.kcRuleConfig.checkResult()) return;
      if (functionCode == 'CPPS' && !this.$refs.cppsRuleConfig.checkResult()) return;
      if (functionCode == 'SSGT' && !this.$refs.ssgtRuleConfig.checkResult()) return;
      if (
        (functionCode == 'BHOTC' ||
          functionCode == 'BHRX' ||
          functionCode == 'BHSY' ||
          functionCode == 'WDXSDD' ||
          functionCode == 'WDCGDD') &&
        !this.bizParam1.isChangePrice
      ) {
        this.$message.error('请选择商品支持改价');
        return;
      }
      if ((functionCode == 'FKSXSDD'|| functionCode == 'FKSCGDD') && !this.$refs.reRuleConfig.checkResult()) return;
      if ((functionCode == 'BHOTC' || functionCode == 'BHRX' || functionCode == 'BHSY') && !this.$refs.bhRuleConfig.checkResult()) return;
      ;
      //判断库存信息收集时标签是否填写
      if (functionCode == 'KCXXCJ' && this.bizParam1.isKcShow == 'Y') {
        if (!this.expiryDateList.length && !this.stockNumList.length) {
          this.$message.error('请添加库存标签！');
          return;
        }
        // 有效期
        try {
          this.expiryDateList.forEach((item) => {
            if (item.tag == '') {
              throw new Error('请填写有效期标签名');
            }
            if (!item.rule.length) {
              throw new Error('请完善有效期规则');
            } else {
              item.rule.forEach((k) => {
                if (!k.ruleConfigType) {
                  throw new Error('请完善有效期规则');
                }
                if (!k.value1) {
                  throw new Error('请完善有效期规则');
                }
                if (k.ruleConfigType == 'gt_lt' && !k.value2) {
                  throw new Error('请完善有效期规则');
                }
              });
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        //库存数
        try {
          this.expiryDateList.forEach((item) => {
            if (item.tag == '') {
              throw new Error('请填写库存数标签名');
            }
            if (!item.rule.length) {
              throw new Error('请完善库存数规则');
            } else {
              item.rule.forEach((k) => {
                if (!k.ruleConfigType) {
                  throw new Error('请完善库存数规则');
                }
                if (!k.value1) {
                  throw new Error('请完善库存数规则');
                }
                if (k.ruleConfigType == 'gt_lt' && !k.value2) {
                  throw new Error('请完善库存数规则');
                }
              });
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
      }
      let bizParam = JSON.parse(JSON.stringify(this.bizParam1));
      bizParam.allowAllocateSelf = this.assignRadio;
      bizParam.isOnlyCamera = bizParam.isOnlyCamera == 'Y' ? true : false;
      bizParam.isAddWaterMark = bizParam.isAddWaterMark == 'Y' ? true : false;
      bizParam.signLocation = {
        maxRadius: bizParam.signLocation.maxRadius ? bizParam.signLocation.maxRadius : 2000,
        allowOutside: bizParam.signLocation.allowOutside == 'Y' ? true : false
      }
      //拜访规则赋值
      if (functionCode == 'SCDY'||functionCode == 'JPXXSJ') {
        let newBizParam =functionCode == 'SCDY'? this.$refs.markingRuleConfig.newBizParam: this.$refs.competitionRuleConfig.newBizParam;
        let { selectItemNum, dayItemBelongSameCustomer, diyDayItemBelongSameCustomer,dayItemSum, diyDayItemSum,dayCustomerSumAndSame, monthItemSameSum, monthCustomerSameSum, dayCustomerSameSum,diyDayCustomerSameSum,diyDayCustomerSumAndSame } = newBizParam;
        let newRuleItemList = [];
        selectItemNum.ruleItemList.forEach(k => {
          newRuleItemList.push({
            'customerType': k
          })
        })
        monthCustomerSameSum.ruleItemList.forEach(k=>{
            k.isSamePersonExecute =  k.isSamePersonExecute?'Y':'N'
        })
        selectItemNum.ruleItemList = newRuleItemList;
        bizParam.selectItemNum = selectItemNum;
        
        bizParam.diyDayItemBelongSameCustomer = diyDayItemBelongSameCustomer;
        bizParam.dayItemBelongSameCustomer = dayItemBelongSameCustomer;
        bizParam.dayItemSum = dayItemSum;
        bizParam.diyDayItemSum = diyDayItemSum;

        bizParam.dayCustomerSumAndSame = dayCustomerSumAndSame;
        bizParam.diyDayCustomerSumAndSame = diyDayCustomerSumAndSame;
        bizParam.monthItemSameSum = monthItemSameSum;
        bizParam.monthCustomerSameSum = monthCustomerSameSum;
        bizParam.dayCustomerSameSum = dayCustomerSameSum;
        bizParam.diyDayCustomerSameSum = diyDayCustomerSameSum;
      }
  
      //CPPS规则赋值
      if (functionCode == 'CPPS') {
        let newBizParam = this.$refs.cppsRuleConfig.newBizParam;
        let {dayCustomerSameSum } = newBizParam;
        bizParam.dayCustomerSameSum = dayCustomerSameSum;
      }
      //SSGT规则赋值
      if (functionCode == 'SSGT') {
        let newBizParam = this.$refs.ssgtRuleConfig.newBizParam;
        let {dayCustomerSameSum } = newBizParam;
        bizParam.dayCustomerSameSum = dayCustomerSameSum;
      }
      if (functionCode == 'ZBHZTJ') {
        let newBizParam = this.$refs.zbRuleConfig.newBizParam;
        let { dayCustomerSumNotSame, dayItemBelongSameCustomer, diyDayItemBelongSameCustomer,monthItemSameSum, monthCustomerSameSum } = newBizParam;
        dayItemBelongSameCustomer.ruleItemList = [dayItemBelongSameCustomer.ruleItemList[0]]
        diyDayItemBelongSameCustomer.ruleItemList = [diyDayItemBelongSameCustomer.ruleItemList[0]]
        monthItemSameSum.ruleItemList = [monthItemSameSum.ruleItemList[0]]
        monthCustomerSameSum.ruleItemList = [monthCustomerSameSum.ruleItemList[0]]
        bizParam.dayCustomerSumNotSame = dayCustomerSumNotSame;
        bizParam.dayItemBelongSameCustomer = dayItemBelongSameCustomer;
        bizParam.diyDayItemBelongSameCustomer = diyDayItemBelongSameCustomer;
        bizParam.monthItemSameSum = monthItemSameSum;
        bizParam.monthCustomerSameSum = monthCustomerSameSum;
      }
      if (functionCode == 'BHOTC' || functionCode == 'BHRX' || functionCode == 'BHSY') {
        let newBizParam = this.$refs.bhRuleConfig.newBizParam;
        let { selectMedProductQtySum,dayBizDataSum, selectProductQtySum ,monthOrderSumProduct,monthOrderSumCompetitor,orderDayCustomerSameSum} = newBizParam;
        bizParam.selectMedProductQtySum = selectMedProductQtySum;
        bizParam.dayBizDataSum = dayBizDataSum;
        bizParam.monthOrderSumProduct = monthOrderSumProduct;
        bizParam.monthOrderSumCompetitor = monthOrderSumCompetitor;
        bizParam.selectProductQtySum = selectProductQtySum;
        bizParam.orderDayCustomerSameSum = orderDayCustomerSameSum;
      }
      if (functionCode == 'FKSXSDD') {
        let newBizParam = this.$refs.reRuleConfig.newBizParam;
        let { selectMedProductQtySum} = newBizParam;
        bizParam.selectMedProductQtySum = selectMedProductQtySum;
      }
      if (functionCode == 'KCXXCJ') {
        let newBizParam = this.$refs.kcRuleConfig.newBizParam;
        let { dayBizDataSum, selectProductStockQty,dayCustomerSumAndSame,monthCustomerSameSum, monthCustomerSameStaff, monthCustomerDifferentStaff } = newBizParam;
        bizParam.dayBizDataSum = dayBizDataSum;
        bizParam.selectProductStockQty = selectProductStockQty;
        bizParam.monthCustomerDifferentStaff = monthCustomerDifferentStaff;
        bizParam.monthCustomerSameStaff = monthCustomerSameStaff;
        bizParam.dayCustomerSumAndSame = dayCustomerSumAndSame;
        bizParam.monthCustomerSameSum = monthCustomerSameSum;
      }
       if (functionCode == 'YWCL') {
        let newBizParam = this.$refs.goodsShowRuleConfig.newBizParam;
        let { monthCustomerSameStaff, monthCustomerDifferentStaff } = newBizParam;
        bizParam.monthCustomerDifferentStaff = monthCustomerDifferentStaff;
        bizParam.monthCustomerSameStaff = monthCustomerSameStaff;
      }

      if (this.departmentList.length != 0) {
        var req = {
          serviceTenantGuid: localStorage.guid,
          tenantName: this.tenantName,
          functionGuid: this.$route.query.functionGuid,
          tenantFunctionGuid: this.$route.query.type == 1 ? this.$route.query.guid : null,
          fieldList: this.fieldList,
          tenantGuid,
          organisationGuid: organisationGuid ? [organisationGuid] : null,
          organisationName: organisationName ? [organisationName] : null,
          bizParam,
        };
      } else {
        var req = {
          serviceTenantGuid: localStorage.guid,
          tenantName: this.tenantName,
          functionGuid: this.$route.query.functionGuid,
          tenantFunctionGuid: this.$route.query.type == 1 ? this.$route.query.guid : null,
          fieldList: this.fieldList,
          organisationGuid: organisationGuid ? [organisationGuid] : null,
          organisationName: organisationName ? [organisationName] : null,
          tenantGuid,
          bizParam,
        };
      }
      req.fieldList.forEach((i) => {
        i.showPosition = i.showPosition.toString(',');
      });
      //库存判断
      if (this.expiryDateList.length > 0) {
        bizParam.expiryDate = this.expiryDateList;
      }
      //库存判断
      if (this.stockNumList.length > 0) {
        bizParam.stockNum = this.stockNumList;
      }
      let self = this;
      req.bizParam.visitRadioList = this.visitRadioList;
      req.bizParam.holidayRuleList = this.holidayRuleList;
      // 采集日期规则
      req.bizParam.accountMonthCheckRule = this.bizParam1.accountMonthCheckRule;
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msConfigureService}/function/function-tenant-field/save`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (type == 1) {
            this.preview(tenantGuid, organisationGuid);
          } else {
            self.dialogVisible = false;
            self.$message.success('新增成功');
            self.fullscreenLoading = false;
            self.$router.go(-1);
          }
        } else {
          self.$message.error(res.data.msg);
          self.fullscreenLoading = false;
        }
      });
    },
  }
};


